import es from './lang/es'
import pt from './lang/pt'
import { getLanguageFromURL } from './util/translate'

export const supportedLangs = [
  'es',
  'pt'
]

export const lang: Record<string, Record<'singular' | 'plural', Record<string, string>>> = {
  es,
  pt,
}

export const hreflangDict: Record<string, string> = {
  es: 'es-es',
  pt: 'pt-pt',
}

let envLangCache = ''
export function getCurrentENVLanguage() {
  if (!envLangCache.length) {
    const config = useRuntimeConfig()
    envLangCache = config.public.language
  }

  return envLangCache
}

export function getCurrentURLLanguage() {
  const route = useRoute()

  // NOTE: Para las URLs estáticas, este parámetro no tiene valor.
  const urlLang = route.params.lang as string
  if (urlLang) {
    return urlLang
  }

  return getLanguageFromURL(route.path)
}

export function getCurrentLanguage() {
  const urlLang = getCurrentURLLanguage()
  if (urlLang) {
    return urlLang
  }

  // NOTE: Actualmente esto no va a usarse nunca, ya que 'getCurrentURLLanguage' siempre va a retornar un valor.
  return getCurrentENVLanguage()
}

export function langToCountryISO2(lang: string): string {
  const map: Record<string, string> = {
    es: 'ES',
    pt: 'PT',
  }

  const code = map[lang] || 'ES'
  return code
}
